import Types from "./Types";

const INITIAL_STATE = {
  teachers: [],
  teacherCourses: [],
  subjects: [],
  teacher: {},
  isLoading: false,
  count: "",
};

export default function publicData(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_PUBLIC_TEACHERS_SUCCESS: {
      return {
        ...state,
        teachers: payload.data,
        count: payload.data.length,
      };
    }

    case Types.GET_PUBLIC_SUBJECTS_SUCCESS: {
      return {
        ...state,
        subjects: payload.data,
        count: payload.data.length,
      };
    }
    case Types.GET_PUBLIC_TEACHER_SUCCESS: {
      return {
        ...state,
        teacher: payload.data,
      };
    }

    case Types.GET_PUBLIC_TEACHER_COURSES_SUCCESS: {
      return {
        ...state,
        teacherCourses: payload.data,
      };
    }
    case Types.PUBLIC_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    default: {
      return state;
    }
  }
}
